const goldenRatioLineHeight = (fontSize) => `${fontSize * 1.618}px`; 

export const PMITheme = {  
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      light: "#00BDFE",
      main: "#004F90",
    },
    secondary: {
      light: "#00BDFE",
      main: "#004F90",
    },
    error: {
      dark: "#dd838cff",
      main: "#FF7588",
      light: "#FF758866"
    },
    warning: {
      dark: "#d4a600ff",
      main: "#F0C775"
    },
    success: {
      main: "#57C2AB"
    },
    text: {
      primary: "#000",
      secondary: "#fff",
    },
    background: {
      default: "#fff",
      paper: "#fff"
    },
    status: {
      default: '#859cafff'
    }
  },
  typography: {
    htmlFontSize: 10,
    fontFamily: "Lato",
    fontWeightRegular: 400,
    fontWeightBold: 700,
    fontWeightBlack: 900,
    fontSize: 10,
    useNextVariants: true,
    body1: {
      fontFamily: "Lato",
      fontSize: "1.4rem"
    },
    h1: {
      fontSize: 42,
      lineHeight: goldenRatioLineHeight(42),
      fontFamily: 'Lato',
      fontWeight: 900
    },
    h2: {
      fontSize: 36,
      lineHeight: goldenRatioLineHeight(36),
      fontFamily: 'Lato',
      fontWeight: 900
    },
    h3: {
      fontSize: 24,
      lineHeight: goldenRatioLineHeight(24),
      fontFamily: 'Lato',
      fontWeight: 900
    },
    h4: {
      fontSize: 20,
      lineHeight: goldenRatioLineHeight(20),
      fontFamily: 'Lato',
      fontWeight: 900
    },
    h5: {
      fontSize: 14,
      lineHeight: goldenRatioLineHeight(16),
      fontFamily: 'Lato',
      fontWeight: 900
    },
    h6: {
      fontSize: 12,
      lineHeight: goldenRatioLineHeight(12),
      fontFamily: 'Lato',
      fontWeight: 900
    }
  },
  shape: {
    borderRadius: 4
  },
  spacing: 4,
  overrides: {
    MuiFilledInput: {
      root: {
        backgroundColor: "#fff"
      }
    },
    MuiInputLabel: {
      root: {
        color: "#004F90",
      }
    },
    MuiTextField: {
      root: {
        color: "#004F90"
      },
    },
    MuiButton: {
      root: {
        textTransform: "none",
        padding: "4px 12px"
      },
    },
    MuiTabs: {
      color: '#004F90',
      indicator: {
        backgroundColor: '#004F90'
      }
    },
    MuiTab: {
      root: {
        color: '#004F90',
        "&:hover": {
          backgroundColor: '#fff',
          color: '#004F90'
        },
        "&$selected": {
          color: '#004F90'            
        }
      },
    },
    MuiCardHeader: {
      root: {
        padding: 0,
        fontWeight: 900,
      }
    },
    MuiCardContent: {
      root: {
        padding: 0
      }
    }
  },
  props: {
    MuiButton: {
      disableRipple: true,
      variant: "contained",
      color: "primary"
    },
    MuiCheckbox: {
      disableRipple: true
    },
    MuiTextField: {
      variant: "filled",
      InputLabelProps: {
        shrink: true
      }
    },
    MuiPaper: {
      elevation: 0
    },
    MuiCard: {
      elevation: 0
    }
  }
};